import React from 'react';
import {CModal} from "@coreui/react";
import './IensoModalWindow.scss'
import PropTypes from "prop-types";
import {IensoButton} from "../../index";
import {BsXCircle} from "react-icons/bs";

export const IensoModalWindow = React.memo(({
  children, isOpen, toggle, title,
  onSaveLabel, onCloseLabel, onCustomLabel,
  onSave, onClose, onCustom, size,
  showButtons, buttonsSize, onSaveDisabled, modalSize,
}) => {
  return (
    <div className={'ienso-modal-window'}>
      <CModal
        show={isOpen}
        centered
        onClose={toggle}
        className={modalSize ? '' : size}
        size={modalSize}
      >
        <div className={'ienso-modal-window__dialog'}>
          <div className={'ienso-modal-window__header'}>
            <span className={'ienso-modal-window__title text-subheading-1'}>{title}</span>
            <button className={'ienso-modal-window__close-btn'} onClick={toggle}>
              <BsXCircle />
            </button>
          </div>

          <div className={'ienso-modal-window__body'}>
            {children}
          </div>

          {showButtons && (
            <div className={'ienso-modal-window__footer'}>
              {onCustomLabel && (
                <IensoButton onClick={onCustom} size={buttonsSize} styleType={'modal-secondary'}>
                  {onCustomLabel}
                </IensoButton>
              )}
              <IensoButton onClick={onClose} size={buttonsSize} styleType={'modal-secondary'}>
                {onCloseLabel}
              </IensoButton>
              <IensoButton onClick={onSave} size={buttonsSize} styleType={'modal-main'} disabled={onSaveDisabled}>
                {onSaveLabel}
              </IensoButton>
            </div>
          )}
        </div>
      </CModal>
    </div>
  );
})

IensoModalWindow.propTypes = {
  children: PropTypes.node,
  size: PropTypes.string,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  title: PropTypes.string,
  onSaveLabel: PropTypes.string,
  onCloseLabel: PropTypes.string,
  onCustomLabel: PropTypes.string,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  onCustom: PropTypes.func,
  showButtons: PropTypes.bool,
}

IensoModalWindow.defaultProps = {
  children: null,
  size: 'md',
  buttonsSize: 'sm',
  isOpen: false,
  toggle: () => undefined,
  title: 'Title is here',
  onSaveLabel: 'Save',
  onCloseLabel: 'Cancel',
  onCustomLabel: '',
  onSave: () => undefined,
  onClose: () => undefined,
  onCustom: () => undefined,
  showButtons: true,
}
